import { render, staticRenderFns } from "./SQuesThirtySix.vue?vue&type=template&id=a7244806&scoped=true&"
import script from "./SQuesThirtySix.vue?vue&type=script&lang=js&"
export * from "./SQuesThirtySix.vue?vue&type=script&lang=js&"
import style0 from "./SQuesThirtySix.vue?vue&type=style&index=0&id=a7244806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7244806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCardText,VDialog})
